export const RAINBOW_CATEGORY_ID_TO_LABEL = {
  1: 'Health & Healing RC',
  2: 'Yoga RC',
  3: 'Meditation RC',
  4: 'Spiritual Growth RC',
  5: 'Expanded Consciousness RC',
  6: 'Hidden History RC',
  7: 'Supernatural RC',
  8: 'Unexplained RC',
  9: 'Coverups RC',
}

export const RAINBOW_CATEGORY_AFFINITY_VALUES = [
  {
    label: 'Users 1st affinity',
    value: 'first',
  },
  {
    label: 'Users 2nd affinity',
    value: 'second',
  },
  {
    label: 'Users 3rd affinity',
    value: 'third',
  },
]

export const RAINBOW_CATEGORY_TARGET_METHOD = 'rainbow-category'
